module.exports = __webpack_public_path__ + "img/picture_18.14ff5c2f.png";